import { AIExtractionErrorMessages } from 'common/constants/aiExtraction';

export enum AutopilotImportErrors {
  missingTextOrFiles = 'either_text_or_files_must_be_provided',
  columnMappingFailed = 'failed_to_map_csv_columns_to_expected_format',
  noValidColumnMappings = 'no_valid_column_mappings_found',
  missingRequiredColumns = 'missing_required_column_mappings_for_file',
  noMappingForFile = 'no_mapping_found_for_csv_file_at_index',
  emptyTextColumn = 'text_column_cannot_be_empty',
  invalidTextColumn = 'text_column_must_contain_text',
  emptyEmailColumn = 'email_column_cannot_be_empty',
  invalidEmailFormat = 'invalid_email_format',
  invalidUrlFormat = 'invalid_url_format',
  missingRequiredData = 'missing_required_data',
  userNotFound = 'user_with_id_not_found',
  userOrCompanyNotFound = 'user_or_company_not_found',
  noItemsToUpsert = 'no_items_to_upsert',
  emptyTextContent = 'text_content_cannot_be_empty',
  errorProcessingRow = 'error_processing_row',
  emptyFile = 'empty_file',
}

export const AutopilotImportErrorMessages = {
  ...AIExtractionErrorMessages,
  [AutopilotImportErrors.missingTextOrFiles]:
    'Please provide either text content or upload files to import',
  [AutopilotImportErrors.columnMappingFailed]: "We couldn't match columns to the expected format",
  [AutopilotImportErrors.noValidColumnMappings]:
    "We couldn't find any matching columns in your file",
  [AutopilotImportErrors.missingRequiredColumns]: 'Your file is missing some required columns',
  [AutopilotImportErrors.noMappingForFile]: "We couldn't find the required columns in your file",
  [AutopilotImportErrors.emptyTextColumn]:
    'The text column cannot be empty. Please provide content for this field',
  [AutopilotImportErrors.invalidTextColumn]: 'The text column must contain actual text content',
  [AutopilotImportErrors.emptyEmailColumn]:
    'The email column cannot be empty. Please provide email addresses',
  [AutopilotImportErrors.invalidEmailFormat]: 'Please provide valid email addresses',
  [AutopilotImportErrors.invalidUrlFormat]: 'Please provide valid URLs',
  [AutopilotImportErrors.missingRequiredData]:
    'Some required information is missing. Please check your data',
  [AutopilotImportErrors.userNotFound]: "We couldn't find the specified user",
  [AutopilotImportErrors.userOrCompanyNotFound]: "We couldn't find the specified user or company",
  [AutopilotImportErrors.noItemsToUpsert]: 'No items were found to import',
  [AutopilotImportErrors.emptyTextContent]:
    'Text content cannot be empty. Please provide some content',
  [AutopilotImportErrors.errorProcessingRow]: 'There was an error processing one of your data rows',
  [AutopilotImportErrors.emptyFile]: 'The file is empty. Please provide a valid file',
};
